import Vue from 'vue'
import VueRouter from 'vue-router'
import canAccessRma from './rma-access'

import Dashboard from '@/views/tableau-de-bord'
const AdminDashboard = () => import('@/views/tableau-de-bord/dashboard-admin')
const InfirmierDashboard = () => import('@/views/tableau-de-bord/dashboard-infirmier')
const MedecinDashboard = () => import('@/views/tableau-de-bord/dashboard-medecin')
const LaboratinDashboard = () => import('@/views/tableau-de-bord/dashboard-laboratin')

const AddPatient = () => import('@/views/addPatient')
const Patients = () => import('@/views/listePatient')
// Le dossier est ouvert depuis plusieurs files du tableau de bord : préparer
// son code pendant l'attente du praticien évite un téléchargement au clic.
const PatientInfo = () => import(/* webpackPrefetch: true */ '@/views/patientInfo')

const AjouterAnalyse = () => import('@/views/creerAnalyse')
const ListeAnalyse = () => import('@/views/listeAnalyse')
const ListeModelesAnalyse = () => import('@/views/modeles-analyses/liste')

const CreerModifierModeleAnalyse = () => import('@/views/modeles-analyses/editer')

const SaisieResultasAnalyse = () => import('@/views/analyse/resultats-analyses/saisie-resultats')

const EditerAnalyse = () => import('@/views/editerAnalyse')
const RegistreOthers = () => import('@/views/analyse/others-registre')

const CreerDossier = () => import('@/views/dossierMedical/create')
import Login from '@/views/login'
import store from '@/store'
// >>>>>>>> Consultations
const SalleAttente = () => import('@/views/consultations/salle-attente')

// ========================================>Medecine Du Travail<==============================
// SOCIETE
const ListeSociete = () => import('@/views/mdt/societe/listeSociete')
const CreerSociete = () => import('@/views/mdt/societe/creerSociete')
const SocieteDetails = () => import('@/views/mdt/societe/societeDetails')

const Facturation = () => import('@/views/mdt/facturations/facturations')
const VisitePoste = () => import('@/views/mdt/visite-postes/visite-postes')
const VisiteMedicale = () => import('@/views/mdt/visite-medicales/visite-medicales')
const ParamVisiteMedicale = () => import('@/views/mdt/visite-medicales/parametrages-globaux')
const CategorieVisiteMedicale = () => import('@/views/mdt/visite-medicales/categories')
const VisiteMedicaleListWrapper = () => import('@/views/mdt/visite-medicales/categories/category-wrapper')
const AccidentMaladie = () => import('@/views/mdt/accidents-maladies-pro/accident-maladie-pro')
const Rapport = () => import('@/views/mdt/rapports/rapports')
const TravailleurInfo = () => import('@/views/mdt/travailleurs/travailleur-info')
const Certificats = () => import('@/views/mdt/certificats')
const DocumentUnique = () => import('@/views/mdt/document-unique')
// ========================================>Medecine Du Travail<==============================

// ===============          PARAMETRES          ==============
const Parametres = () => import('@/views/parametres')
const Assurances = () => import('@/views/parametres/assurances')
const ListeSouscripteurs = () => import('@/views/parametres/assurances/liste-assures')
const Souscripteur = () => import('@/views/parametres/assurances/liste-assures/assure-detail')
const TarificationCatOnmt = () => import('@/views/parametres/tarifications')
const AssuranceGroupes = () => import('@/views/parametres/assurances/assurance-groupes')
const AssuranceGroupeList = () => import('@/views/parametres/assurances/assurance-groupe-list')
const AssureurDetail = () => import('@/views/parametres/assurances/liste-assures/assureur-detail')
const ParamExamensCliniques = () => import('@/views/parametres/examens-cliniques')
const Champ = () => import('@/views/parametres/champs')
const ChampSpecialite = () => import('@/views/parametres/champs/champ-specialite')
const AccesConsultations = () => import('@/views/parametres/accessibilites/acces-consultations')
const AccesExamens = () => import('@/views/parametres/accessibilites/acces-examens')

const PendingResultVisitesMedicales = () => import('@/views/analyse/pending-visites-medicales')
const Resultats = () => import('@/views/analyse/pending-visites-medicales/resultats')
const TarifAdmissions = () => import('@/views/parametres/tarif-admissions')
const TarifActes = () => import('@/views/parametres/tarif-actes')

const PorterResultatExamen = () => import('@/views/examens')
const RegistreExamen = () => import('@/views/examens/registre')
const ExamenAttenteInterpretations = () => import('@/views/examens/attente-interpretations')
const SalleExamen = () => import('@/views/examens/salle-examen')
const RegistreAnalyse = () => import('@/views/analyse/registre_analyse')
const LaboratoireNonConformites = () => import('@/views/laboratoire/non-conformites')   // LAB-UI-2
const StockLaboratoire = () => import('@/views/laboratoire/stock')   // STOCK-LABO SL-2
const ServiceStock = () => import('@/views/service-stock')
const ServiceStockArticle = () => import('@/views/service-stock/article')
const ResultatsAnalysesCircuit = () => import('@/views/resultats-analyses-circuit')   // LAB-RES-001
const StatDiagnostiques = () => import('@/views/consultations/statistique-diagnostiques')
const SoinsAFaireInfirmier = () => import('@/views/tableau-de-bord/dashboard-infirmier/soins-a-faire/page')
const OccupationLits = () => import('@/views/tableau-de-bord/dashboard-infirmier/occupation-lits.vue')

// import Configs from '@/views/parametres/configs'
const Profil = () => import('@/views/parametres/profil')
const Etablissement = () => import('@/views/parametres/etablissement')
const EquipeAcces = () => import('@/views/parametres/equipe-acces')
const DossierSoins = () => import('@/views/parametres/dossier-soins')
const LaboratoireImagerie = () => import('@/views/parametres/laboratoire-imagerie')
const PrestationsTarifs = () => import('@/views/parametres/prestations-tarifs')
import BlockedUI from '@/components/blocked-ui'


Vue.use(VueRouter)

const routes = [
    { path: '/guide-utilisation', name: 'GuideUtilisation', component: () => import('@/views/guide-utilisation/index.vue') },
    {
        path: '/blocked',
        name: 'Access Denied',
        component: BlockedUI,
    },

    {
        path: '/',
        name: 'Index',
        redirect: '/dashboard'
    },
    {
        // Demandes des sites : dans Accueil / Caisse › Rendez-vous depuis le 04/10/2026 ; anciens liens vers le tableau de bord.
        path: '/rendez-vous/demandes-web', redirect: '/dashboard',
    },
    {
        path: '/dashboard',
        name: 'Tableau de bord',
        component: Dashboard,
    },
    {
        path: '/dashboard-admin',
        name: 'Administrateur',
        component: AdminDashboard,
    },
    {
        path: '/dashboard-admin',
        name: 'Infirmier',
        component: InfirmierDashboard,
    },
    {
        path: '/dashboard-admin',
        name: 'Medecin',
        component: MedecinDashboard,
    },
    {
        path: '/dashboard-admin',
        name: 'Laboratin',
        component: LaboratinDashboard,
    },
    {
        path: '/dashboard/salle-attente',
        name: 'Salle d\'attente',
        component: SalleAttente,
    },
    {
        path: '/patients/ajouter/:patient_id',
        name: 'AjouterPatient',
        component: AddPatient
    },
    {
        path: '/patients',
        name: 'liste-patients',
        component: Patients
    },
    {
        path: '/patients/:id/:consultation',
        name: 'patientInfo',
        component: PatientInfo,
        props: true,
        children: [
            
        ]
    },
    {
        path: '/analyses/ajouter',
        name: 'creerAnalyse',
        component: AjouterAnalyse
    },
    {
        path: '/parametres/champs',
        name: 'Champs',
        component: Champ
    },
    {
        path: '/parametres/champs/access-par-specialite',
        name: 'Accès Champ',
        component: ChampSpecialite
    },

    {
        path: '/parametres/accessibilite/consultations',
        name: 'Accès Consultations',
        component: AccesConsultations
    },
    {
        path: '/parametres/accessibilite/examens',
        name: 'Accès Examens',
        component: AccesExamens
    },

    {
        path: '/parametres/analyses',
        name: 'listeAnalyse',
        component: ListeAnalyse
    },
    
    {
        path: '/parametres/modeles-analyses',
        name: 'listeModelesAnalyse',
        component: ListeModelesAnalyse,
    },

    {
        path: '/parametres/modeles-analyses/:id(\\d+)?/:action(creer|editer)',
        name: 'creerModifierModeleAnalyse',
        component: CreerModifierModeleAnalyse,
    },

    {
        path: '/analyses/:analyseId/patients/:patientId/resultats',
        name: 'saisie-resultats-analyse',
        component: SaisieResultasAnalyse
    },

    {
        path: '/analyses/editer/:id',
        name: 'editerAnalyse',
        component: EditerAnalyse
    },
    {
        path: '/analyses/registre-others/:analyse_id',
        name: 'Registre others',
        component: RegistreOthers
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/patients/:id/creer-dossier-medical',
        name: 'dossier_create',
        component: CreerDossier
    },

    {
        path: '/examens/registre',
        name: 'Registre examen',
        component: RegistreExamen
    },

    {
        path: '/examens/interpreter',
        name: 'Attente interpretation',
        component: ExamenAttenteInterpretations
    },
    {
        path: '/examens/salle-examen/:examen_id',
        name: 'Salle examen',
        component: SalleExamen
    },

    {
        path: '/examens/porter-resultat',
        name: 'Porter résultat',
        component: PorterResultatExamen
    },

    {
        path: '/registre/analyses',
        name: 'Registre Analyse',
        component: RegistreAnalyse
    },
    {
        path: '/laboratoire/non-conformites',
        name: 'Registre des non-conformites',
        component: LaboratoireNonConformites
    },
    {
        path: '/laboratoire/stock',
        name: 'Stock du laboratoire',
        component: StockLaboratoire
    },
    {
        path: '/service/stock',
        name: 'Stock du service',
        component: ServiceStock
    },
    {
        path: '/service/stock/:stockId/produit/:articleId',
        name: 'Détail du produit du service',
        component: ServiceStockArticle
    },
    {
        // LAB-RES-001 : page « Résultats » — suivi du circuit des analyses (médecins et infirmiers)
        path: '/resultats-analyses',
        name: 'Resultats analyses',
        component: ResultatsAnalysesCircuit
    },
    // +++++++++++++        MEDECINE DU TRAVAIL     +++++++++++++++
    // {
    //     path: '/societes',
    //     name: 'Societe',
    //     component: Societe
    // },
    {
        path: '/facturations',
        name: 'Facturation',
        component: Facturation
    },
    {
        path: '/visites-de-postes',
        name: 'VisitePoste',
        component: VisitePoste
    },
    {
        path: '/visite-medicales/resultats/pending',
        name: 'VisiteMedicalePendingResult',
        component: PendingResultVisitesMedicales
    },
    {
        path: '/visite-medicales/resultats/pending/:id',
        name: 'VisiteMedicalePendingResultList',
        component: Resultats
    },
    {
        path: '/visite-medicales',
        name: 'VisiteMedicale',
        component: VisiteMedicale
    },
    {
        path: '/visite-medicales/parametrages',
        name: 'ParamVisiteMedicale',
        component: ParamVisiteMedicale
    },
    {
        path: '/visite-medicales/categories',
        name: 'categorieVisiteMedicale',
        component: CategorieVisiteMedicale
    },
    {
        path: '/visite-medicales/categories/:id',
        name: 'categorieVisiteMedicaleItems',
        component: VisiteMedicaleListWrapper
    },
    {
        path: '/accident-maladie-pro',
        name: 'AccidentMaladie',
        component: AccidentMaladie
    },
    {
        path: '/rapports',
        name: 'Rapport',
        component: Rapport
    },
    {
        path: '/certificats',
        name: 'Certificats',
        component: Certificats
    },
    {
        path: '/document-unique',
        name: 'DocumentUnique',
        component: DocumentUnique
    },

    {
        path: '/societes',
        name: 'liste_societes',
        component: ListeSociete
    },
    {
        path: '/societes/creer-societe',
        name: 'creer_societes',
        component: CreerSociete
    },
    {
        path: '/societes/:id',
        name: 'profilSociete',
        component: SocieteDetails
    },
    {
        path: '/societes/:id/:params',
        name: 'Parametrage_Societe',
        component: SocieteDetails
    },
    {
        path: '/societes/:id/:travailleurs',
        name: 'profilSocieteSections',
        component: SocieteDetails
    },
    {
        path: '/travailleur/:travailleur_id',
        name: 'TravailleurInfo',
        component: TravailleurInfo
    },

    // +++++++++    Paramètres      ++++++++++++
    {
        path: '/parametres',
        name: 'Parametres',
        component: Parametres
    },
    {
        path: '/parametres/assurances',
        name: 'Assurances',
        component: Assurances
    },
    {
        path: '/parametres/assurances/groupe/:id',
        name: 'Groupe Assurance',
        component: AssuranceGroupes,
    },
    {
        path: '/parametres/groupe-assurance',
        name: 'Groupe Assurance',
        component: AssuranceGroupeList,
    },
    {
        path: '/parametres/assureur/:id',
        name: 'Assureur',
        component: ListeSouscripteurs
    },
    {
        path: '/parametres/assureur/:id/souscripteur/:assure_id',
        name: 'Souscripteur',
        component: Souscripteur
    },
    {
        path: '/parametres/assureur/:id/detail/souscripteur/:assure_id',
        name: 'Souscripteur',
        component: AssureurDetail
    },

    // >>>>>>>>>        PARAM Tarification 
    {
        path: '/parametres/tarification-cat-onmt',
        name: 'TarificationCatOnmt',
        component: TarificationCatOnmt
    },
    {
        path: '/parametres/examens-cliniques',
        name: 'ExamensCliniquesParam',
        component: ParamExamensCliniques
    },
    {
        path: '/parametres/tarif-admissions',
        name: 'TarifAdmissions',
        component: TarifAdmissions
    },
    {
        path: '/parametres/tarif/acte-soins',
        name: 'TarifActes',
        component: TarifActes
    },

    // STATS DIAGNOSTICS
    {
        path: '/rma',
        alias: '/dashboard/statistiques-sante',
        name: 'RMA',
        component: StatDiagnostiques,
        meta: { rma: true }
    },

    // {
    //     path: '/parametres/configs',
    //     name: 'Configurations',
    //     component: Configs
    // },

    {
        path: '/parametres/profil',
        name: 'Profil',
        component: Profil
    },

    {
        path: '/parametres/etablissement',
        name: 'Etablissement',
        component: Etablissement
    },

    {
        path: '/parametres/equipe-acces',
        name: 'EquipeAcces',
        component: EquipeAcces
    },

    {
        path: '/parametres/dossier-soins',
        name: 'DossierSoins',
        component: DossierSoins
    },

    {
        path: '/parametres/laboratoire-imagerie',
        name: 'LaboratoireImagerie',
        component: LaboratoireImagerie
    },

    {
        path: '/parametres/prestations-tarifs',
        name: 'PrestationsTarifs',
        component: PrestationsTarifs
    },

    {
        path: '/admissions',
        name: 'Profil',
        // Ancienne page retirée : conserver les favoris sans réactiver l'écran.
        redirect: '/parcours-patients'
    },
    {
        // Parcours patient (04/10/2026) : où est chaque patient et depuis quand ; médecin et infirmier.
        path: '/parcours-patients',
        name: 'Parcours patient',
        component: () => import('@/views/parcours-patients'),
        meta: { parcoursSoignants: true }
    },
    {
        path: '/soins-a-faire',
        name: 'Soins à faire',
        component: SoinsAFaireInfirmier,
        meta: { soinsInfirmier: true }
    },
    {
        path: '/occupation-lits',
        name: 'Occupation des lits',
        component: OccupationLits,
        meta: { soinsInfirmier: true }
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

// Les paramètres communs changent rarement : éviter deux lectures réseau à
// chaque changement de page, sans bloquer la navigation ni empêcher leur mise
// à jour explicite depuis les écrans de paramètres.
let configSession = ''
let configLoads = {}
const CONFIG_REFRESH_MS = 5 * 60 * 1000

function chargerConfigNavigation(authInfo) {
    if (!authInfo) return
    const session = String(authInfo.id) + ':' + String(authInfo.access_token || '')
    if (session !== configSession) {
        configSession = session
        configLoads = {}
    }
    const configsCommunes = ['info_clinique', 'currency']
    configsCommunes.forEach(type => {
        const lecture = configLoads[type]
        if (lecture && Date.now() - lecture.date < CONFIG_REFRESH_MS) return
        const promesse = store.dispatch('getConfigInfoClinique', type)
        configLoads[type] = { date: Date.now(), promesse }
        promesse.catch(() => {
            if (configLoads[type] && configLoads[type].promesse === promesse) delete configLoads[type]
        })
    })
}

router.beforeEach((to, from, next) => {
    // Une session absente doit atteindre /login sans lancer les lectures protégées.
    if (!store.getters['authInfo']) return next(to.name === 'login' ? undefined : '/login')
    if (to.meta.soinsInfirmier && store.getters['activeRole'] && store.getters['activeRole'].nom !== 'ROLE_INFIRMIER') return next('/dashboard')
    if (to.meta.parcoursSoignants && store.getters['activeRole'] && ['ROLE_MEDECIN', 'ROLE_INFIRMIER'].indexOf(store.getters['activeRole'].nom) < 0) return next('/dashboard')
    if (store.getters['authInfo'] && to.meta.rma && !canAccessRma(store.getters['activeRole'])) {
        next('/dashboard')
        return
    }
    let access = false;
    let role;
    let role_actif
    if (store.getters['authInfo']) {
        role = store.getters['authInfo'].roles
        access = false
        for (let index = 0; index < role.length; index++) {
            if (
                role[index].nom == "ROLE_INFIRMIER" || role[index].nom == "ROLE_MEDECIN" ||
                role[index].nom == "ROLE_ADMINISTRATEUR" || role[index].nom == "ROLE_TECH_SUP_LABO" || role[index].nom == "ROLE_MEDECIN_BIOLOGISTE" ||
                role[index].nom == "ROLE_MEDECIN_TRAVAIL" || role[index].nom == "ROLE_SAGE_FEMME" || 
                role[index].nom == "ROLE_INFIRMIER_MEDECINE_TRAVAIL" || role[index].nom == "ROLE_TECHNICIEN_IMAGERIE" || 
                role[index].nom == "ROLE_RADIOLOGUE"
            ) {
                if (store.getters['activeRole']) {
                    role_actif = store.getters['activeRole'].nom
                    if (
                        role_actif != 'ROLE_INFIRMIER' && role_actif != 'ROLE_MEDECIN' && role_actif != 'ROLE_TECH_SUP_LABO' && role_actif != 'ROLE_MEDECIN_BIOLOGISTE' &&
                        role_actif != 'ROLE_ADMINISTRATEUR' && role_actif != 'ROLE_MEDECIN_TRAVAIL' && 
                        role_actif != 'ROLE_SAGE_FEMME' && role_actif != 'ROLE_INFIRMIER_MEDECINE_TRAVAIL' && role_actif != 'ROLE_TECHNICIEN_IMAGERIE' && 
                        role_actif != 'ROLE_RADIOLOGUE'
                    ) {
                        if (role[index].pivot.is_active != true || role[index].pivot.is_active != '1' || role[index].pivot.is_active != 1) {
                            store.dispatch('switchRole', { userId: store.getters['authInfo'].id, roleId: role[index].pivot.role_id })
                        }
                    }
                } else {
                    if (role[index].pivot.is_default == 1) {
                        store.dispatch('switchRole', { userId: store.getters['authInfo'].id, roleId: role[index].pivot.role_id })
                    }
                }
                
                access = true
                break;
            } else
                access = false
        }


    }
    if (access === false && to.name != 'login') {
        localStorage.clear();
        return next('/login')
    } else {
        // const user_info = store.getters['authInfo']
        
        // const can_login = user_info?.can_login
        
        // if (can_login && can_login == 1) {
            let countdown = {}
            store.dispatch('getCountDown').then((response) => {
                countdown = response
                if (countdown.is_count == 1 && countdown.duree_restant.days < 0) {
                    router.push('/blocked')
                } 
            })
        // }
        chargerConfigNavigation(store.getters['authInfo'])
        
        next()
    }
})

/**
 * Prevent right-click context menu.
 */
document.addEventListener('contextmenu', event => event.preventDefault());

/**
 * Prevent F12 key and other developer tool shortcuts.
 */
document.onkeydown = function (e) {
    // F12
    if (e.keyCode === 123) {
        return false;
    }
    // Ctrl+Shift+I
    if (e.ctrlKey && e.shiftKey && e.keyCode === 'I'.charCodeAt(0)) {
        return false;
    }
    // Add other shortcuts as needed
};

export default router
